import "./MollyLevinAttorney.module.css";
import AttorneyHeroMinimal from "./sections/AttorneyHeroMinimal";
import ProfileIntroduction from "./sections/ProfileIntroduction";
import PracticeAreas from "./sections/PracticeAreas";
import Timeline from "./sections/Timeline";
import Insights from "./sections/Insights";
import Services from "./sections/Services";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function MollyLevinAttorneyPage() {
  return <div>
      <AttorneyHeroMinimal />
      <ProfileIntroduction />
      <PracticeAreas />
      <Timeline />
      <Insights />
      <Services />
      <Consultation />
      <Footer />
    </div>;
}